import Button from "../components/common/Button";
import Tooltip from "../components/common/Tooltip";
import { useLanguage } from "../components/LanguageProvider/LanguageProvider";
import {
  ChangePasswordIcon,
  DownloadIcon,
  EditIcon,
  EyeIcon,
  PdfIcon,
  TrashIcon,
} from "../icons/CommonIcons";
import {
  applicationStageMap,
  applicationStatusMap,
} from "./applicationStatusConfig";

export const applicationsTableColumns = (
  handleView,
  handleDelete,
  downlaodPdf,
  editApplication,
  language = false
) => [
  {
    header: { en: "Sr. No.", hi: "क्रम संख्या" },
    accessor: "sr_no",
  },
  {
    header: { en: "Applicant Name", hi: "आवेदक का नाम" },
    accessor: "applicant_name",
  },
  {
    header: { en: "Email ID", hi: "ईमेल आईडी" },
    accessor: "email",
  },
  {
    header: { en: "Tracking Number", hi: "ट्रैकिंग नंबर" },
    accessor: "tracking_number",
  },
  {
    header: { en: "Last Updated On", hi: "अंतिम अपडेट तिथि" },
    accessor: "updated_at",
  },
  {
    header: {
      en: "Applied Incentive Claim",
      hi: "आवेदित प्रोत्साहन दावा",
    },
    accessor: "applied_incetive_claim",
  },
  {
    header: { en: "Status", hi: "स्थिति" },
    accessor: "status",
  },
  {
    header: { en: "Action", hi: "कार्यवाही" },
    accessor: "action",
    isAction: true,
    render: (_, row) => {
      const { status_value, stage } = row;
      return (
        <div className="flex justify-center items-center space-x-2">
          {status_value !== applicationStatusMap.draft.value && (
            <div className="relative group">
              <Button
                className="bg-btn hover:opacity:90 text-white p-2 rounded"
                onClick={() => handleView(row)}
              >
                <EyeIcon />
              </Button>
              <Tooltip label={language ? "देखें" : "View"} />
            </div>
          )}
          {status_value === applicationStatusMap.draft.value && (
            <div className="relative group">
              <Button
                className="bg-[#ed5565] hover:bg-[#d54d5b] text-white p-2 rounded"
                onClick={() => handleDelete(row)}
              >
                <TrashIcon />
              </Button>
              <Tooltip label={language ? "हटाएं" : "Delete"} />
            </div>
          )}
          {status_value !== applicationStatusMap.draft.value &&
            status_value !== applicationStatusMap.approved.value && (
              <div className="relative group">
                <Button
                  className="bg-[#ed5565] hover:bg-[#d54d5b] text-white p-2 rounded"
                  onClick={() => downlaodPdf(row)}
                >
                  <PdfIcon />
                </Button>
                <Tooltip
                  label={language ? "पीडीएफ डाउनलोड करें" : "Download Pdf"}
                />
              </div>
            )}
          {(status_value === applicationStatusMap.draft.value ||
            stage === applicationStageMap.user.value) && (
            <div className="relative group">
              <Button
                className="bg-[#5d7186] hover:bg-[#546679] text-white p-2 rounded"
                onClick={() => editApplication(row)}
              >
                <EditIcon />
              </Button>
              <Tooltip label={language ? "बदलें" : "Edit"} />
            </div>
          )}
        </div>
      );
    },
  },
];

export const adminApplicationsTableColumns = (handleView, downloadPdf) => [
  { header: "Sr.No.", accessor: "sr_no" },
  { header: "Applicant Name", accessor: "applicant_name" },
  { header: "CAF Id", accessor: "caf_id" },
  { header: "District", accessor: "district" },
  { header: "Application Number", accessor: "application_number" },
  { header: "Applied Scheme", accessor: "category" },
  { header: "Mobile Number", accessor: "mobile_number" },
  { header: "Last Updated On", accessor: "updated_at" },
  { header: "Applied Incentive Claim", accessor: "applied_incetive_claim" },
  { header: "Status", accessor: "status" },
  { header: "Stage", accessor: "application_stage_name" },
  {
    header: "Action",
    accessor: "action",
    isAction: true,
    render: (_, row) => {
      const { status_value, status, application_stage } = row;
      return (
        <div className="flex justify-center items-center space-x-2">
          {/* {application_stage === "4" && (
            <Button
              className="bg-btn hover:opacity-90 text-white p-2 rounded"
              onClick={() => addTransaction(row)}
            >
              Add Transaction
            </Button>
          )} */}
          {/* {application_stage !== "4" && ( */}
          <div className="relative group">
            <Button
              className="bg-btn hover:opacity-90 text-white p-2 rounded"
              onClick={() => handleView(row)}
            >
              <EyeIcon />
            </Button>

            <Tooltip label="View" />
          </div>
          <div className="relative group">
            <Button
              className="bg-[#ed5565] hover:bg-[#d54d5b] text-white p-2 rounded"
              onClick={() => downloadPdf(row)}
            >
              <PdfIcon />
            </Button>
            <Tooltip label="Download Pdf" />
          </div>
          {/* )} */}
          {/* {status_value !== applicationStatusMap.approved.value &&
            status_value !== applicationStatusMap.paymentDone.value && (
              <Button
                className="bg-[#ed5565] hover:bg-[#d54d5b] text-white p-2 rounded"
                onClick={() => handleDelete(row)}
              >
                <TrashIcon />
              </Button>
            )} */}
        </div>
      );
    },
  },
];

export const transactionTableColumns = [
  { header: { en: "Sr.No.", hi: "क्रम संख्या" }, accessor: "sr_no" },
  { header: { en: "Caf Id", hi: "CAF आईडी" }, accessor: "caf_id" },
  { header: { en: "Unit Name", hi: "यूनिट का नाम" }, accessor: "unit_name" },
  { header: { en: "Payment Mode", hi: "भुगतान का तरीका" }, accessor: "payment_mode" },
  { header: { en: "Status", hi: "स्थिति" }, accessor: "status" },
  { header: { en: "Paid Amount", hi: "भुगतान राशि" }, accessor: "amount" },
  {
    header: {
      en: "Total Eligible Investment",
      hi: "कुल पात्र निवेश",
    },
    accessor: "total_eligible_investment_after_non_eligible_deduction",
  },
  {
    header: {
      en: "Total Maximum Capital Subsidy",
      hi: "कुल अधिकतम पूंजी सब्सिडी",
    },
    accessor: "total_max_capital_subsidy",
  },
  { header: { en: "Subsidy", hi: "सब्सिडी" }, accessor: "subsidy" },
  { header: { en: "Paid for", hi: "भुगतान किसके लिए" }, accessor: "installment" },
  { header: { en: "Created At", hi: "निर्माण तिथि" }, accessor: "created_at" },
];

export const userTableColumns = (handleView) => [
  { header: "Sr.No.", accessor: "sr_no" },
  { header: "CAF Id", accessor: "caf_id" },
  { header: "Applied Scheme", accessor: "applied_scheme" },
  { header: "Name", accessor: "name" },
  { header: "Expected Completion Date", accessor: "expected_completion_date" },
  { header: "Caf Approval Date", accessor: "caf_approval_date" },
  { header: "District", accessor: "district" },
  { header: "Unit Name", accessor: "unit_name" },
  { header: "Mobile Number", accessor: "mobile_number" },
  { header: "Investment", accessor: "investment" },
  { header: "Construction Status", accessor: "construction_status" },
  { header: "Applied For Claim", accessor: "applied_for_claim" },
  { header: "Land", accessor: "land" },
  { header: "143 Approved", accessor: "one_four_three_approved" },
  { header: "Building Plan Approval", accessor: "building_plan_approval" },
  { header: "DTDO Remarks", accessor: "dtdo_remarks" },
  {
    header: "Action",
    accessor: "action",
    isAction: true,
    render: (_, row) => (
      <div className="flex justify-center items-center space-x-2">
        <div className="relative group">
          <Button
            className="bg-btn hover:opacity-90 text-white p-2 rounded m-1"
            onClick={() => handleView(row)}
          >
            <EyeIcon />
          </Button>

          <Tooltip label="View" />
        </div>
      </div>
    ),
  },
];

export const nodalOfficersTableColumns = (
  handleEdit,
  handleChangePassword,
  showDistrict = true
) => {
  const columns = [
    { header: "Sr.No.", accessor: "sr_no" },
    { header: "Name", accessor: "name" },
    showDistrict && { header: "District", accessor: "district_name" },
    { header: "Role Name", accessor: "role_name" },
    { header: "Username", accessor: "username" },
    { header: "Email", accessor: "email" },
    { header: "Mobile Number", accessor: "mobile_number" },
    { header: "Created At", accessor: "created_at" },
    {
      header: "Action",
      accessor: "action",
      isAction: true,
      render: (_, row) => (
        <div className="flex justify-center items-center space-x-2">
          {/* Edit Button with Tooltip */}
          <div className="relative group">
            <Button
              className="bg-green-600 hover:bg-green-700 text-white p-2 rounded m-1"
              onClick={() => handleEdit(row)}
            >
              <EditIcon />
            </Button>

            {/* Tooltip */}
            <Tooltip label="Edit" />
          </div>

          {/* Change Password Button with Tooltip */}
          <div className="relative group">
            <Button
              className="bg-red-600 hover:bg-red-700 text-white p-2 rounded m-1"
              onClick={() => handleChangePassword(row)}
            >
              <ChangePasswordIcon />
            </Button>

            {/* Tooltip */}
            <Tooltip label="Change Password" />
          </div>
        </div>
      ),
    },
  ];
  return columns.filter(Boolean);
};

export const applicationLogsTableColumns = [
  { header: "Sr. No", accessor: "sr_no" },
  { header: "Date And Time", accessor: "created_at" },
  { header: "Status", accessor: "status" },
  { header: "Stage", accessor: "stage" },
  { header: "Remarks", accessor: "remarks", isHtml: true },
  { header: "Uploaded Report", accessor: "uploaded_report", isHtml: true },
];
